import type { Column, Row, RowData } from '@tanstack/react-table';
import { STRING_FILTER_OPERATION } from './operation.js';
import { type StringFilterSchema, stringFilterSchema, stringValueSchema } from './schema.js';

export function typedSetStringColumnFilterValue<TData extends RowData>(
    column: Column<TData, unknown>,
    filterValue: StringFilterSchema
) {
    column.setFilterValue(filterValue);
}

export function stringFilter<TData extends RowData>(
    row: Row<TData>,
    columnId: string,
    filterValue: StringFilterSchema
) {
    const filter = stringFilterSchema.parse(filterValue);
    const value = stringValueSchema.parse(row.getValue(columnId));

    if (filter.operation === STRING_FILTER_OPERATION.inArray.id) {
        const isBlank = value === null || value === undefined;

        if (filter.includeBlanks && isBlank) {
            return true;
        }

        if (isBlank) {
            return false;
        }

        return filter.array.some((item) => {
            return item.trim().toLowerCase() === value.trim().toLowerCase();
        });
    }

    if (value === null || value === undefined) {
        // TODO: Decide how we handle empty values

        return false;
    } else if (filter.value === null || filter.value === undefined) {
        return true;
    }

    const trimmedValue = value.trim().toLowerCase();
    const trimmedFilterValue = filter.value.trim().toLowerCase();

    switch (filter.operation) {
        case STRING_FILTER_OPERATION.equals.id: {
            return trimmedValue === trimmedFilterValue;
        }
        case STRING_FILTER_OPERATION.doesNotEqual.id: {
            return trimmedValue !== trimmedFilterValue;
        }
        case STRING_FILTER_OPERATION.beginsWith.id: {
            return trimmedValue.startsWith(trimmedFilterValue);
        }
        case STRING_FILTER_OPERATION.endsWith.id: {
            return trimmedValue.endsWith(trimmedFilterValue);
        }
        case STRING_FILTER_OPERATION.containsLoose.id: {
            return trimmedFilterValue.split(' ').some((filterEntry) => {
                return trimmedValue.includes(filterEntry.toLowerCase());
            });
        }
        case STRING_FILTER_OPERATION.containsStrict.id: {
            return trimmedFilterValue.split(' ').every((filterEntry) => {
                return trimmedValue.includes(filterEntry.toLowerCase());
            });
        }
        case STRING_FILTER_OPERATION.doesNotContain.id: {
            return !trimmedValue.includes(trimmedFilterValue);
        }
        default: {
            return false;
        }
    }
}
